import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { CustomFormComponent } from '@services/formBuilder/abstract-custom-form-field';
import { MeasurePickerModalComponent } from '../measure-picker-modal/measure-picker-modal.component';

import { TranslateService } from '@ngx-translate/core';
import { compact, find, map } from 'lodash';

/**
 * CVX-6554: the summary reports' "Data to Include" field. The value stays what the old
 * multi-select stored - a flat array of column ids - so saved reports load unchanged.
 */
@Component({
  selector: 'app-measure-picker',
  templateUrl: './measure-picker.component.html',
  styleUrls: ['./measure-picker.component.scss'],
})
export class MeasurePickerComponent extends CustomFormComponent implements OnInit {

  @Input() options: any[] = [];

  public btnTitle: string;
  public selectedLabels: string[] = [];

  constructor(
    private popoverController: PopoverController,
    private translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.refresh();
  }

  public get selectedIds(): string[] {
    const value = this.formValue;
    return compact(Array.isArray(value) ? value : value ? [value] : []);
  }

  public showPicker(): void {
    this.popoverController.create(<any>{
      component: MeasurePickerModalComponent,
      animated: false,
      componentProps: {
        options: this.options,
        selected: this.selectedIds
      }
    }).then((element: HTMLIonPopoverElement) => {
      element.present();
      element.onDidDismiss().then((event) => {
        if (event.data) {
          this.formValue = event.data;
          this.refresh();
        }
      });
    });
  }

  private refresh(): void {
    // saved ids with no option (e.g. a deleted property) are kept in the value but not listed
    this.selectedLabels = compact(map(this.selectedIds, (id) => find(this.options, {id})?.description));
    this.btnTitle = this.translate.instant(this.selectedIds.length ? 'SHARED.Manage_Data' : 'SHARED.Select_Data');
  }
}
